/**
 * Role model. Ordered from least to most privileged for convenience only;
 * every check is an explicit capability lookup, never a numeric comparison.
 */
export const ROLES = ['physician', 'clinical_reviewer', 'editor', 'admin'];
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
/**
 * Capabilities are the single source of truth for authorisation. The API
 * enforces them on every route; the UI only uses them to hide controls.
 */
export const CAPABILITIES = [
    'catalogue:read_published',
    'catalogue:read_unpublished',
    'catalogue:edit_draft',
    'catalogue:submit_for_review',
    'catalogue:clinical_review',
    'catalogue:publish',
    'import:create',
    'import:commit',
    'review:read',
    'review:resolve',
    'users:manage',
    'audit:read',
];
const PHYSICIAN = ['catalogue:read_published'];
const CLINICAL_REVIEWER = [
    ...PHYSICIAN,
    'catalogue:read_unpublished',
    'catalogue:clinical_review',
    'review:read',
    'review:resolve',
];
const EDITOR = [
    ...PHYSICIAN,
    'catalogue:read_unpublished',
    'catalogue:edit_draft',
    'catalogue:submit_for_review',
    'import:create',
    'review:read',
];
const ADMIN = [
    ...new Set([
        ...EDITOR,
        ...CLINICAL_REVIEWER,
        'catalogue:publish',
        'import:commit',
        'users:manage',
        'audit:read',
    ]),
];
export const ROLE_CAPABILITIES = {
    physician: PHYSICIAN,
    clinical_reviewer: CLINICAL_REVIEWER,
    editor: EDITOR,
    admin: ADMIN,
};
export function roleHasCapability(role, capability) {
    return ROLE_CAPABILITIES[role]?.includes(capability) ?? false;
}
/** Roles for which multi-factor authentication is mandatory, not optional. */
export const MFA_REQUIRED_ROLES = ['admin'];
export function mfaRequiredForRole(role) {
    return MFA_REQUIRED_ROLES.includes(role);
}
//# sourceMappingURL=roles.js.map